class ClothSelection extends HTMLElement {
    constructor() {
      super();
      this.initDefaultVariantInfo();
      this.cta = document.querySelector('.product-form__submit[name="add"]');
      this.ctaLabel = this.cta.querySelector('.product-form__submit-text');
      this.mainVariantPicker = document.getElementById('product__variant-picker');
      this.variantSingle = document.getElementById('product__variant-picker-single');
      this.variantSingle ? this.defaultVariant = JSON.parse(this.variantSingle.textContent) : null
      this.mainQuantityInput = document.querySelector('.product input[name="quantity"]');
      this.mainImage = document.querySelector(".product__media-item .product__media");
      this.imageModal = document.querySelector(".product-media-modal__content");
      this.quantity = Number(this.mainQuantityInput.value);
      this.selectedClothInput = null;
      this.selectedClothType = null;
      this.selectedClothColor = null;
      const clothOptionsDataElement = this.querySelector('#product__cloth-options-data');
  
      if (!clothOptionsDataElement) return;

      this.clothOptionsData = JSON.parse(clothOptionsDataElement.textContent);
      this.clothOptionInputs = this.querySelectorAll('input[type="radio"]');
      this.clothTypesInputs = this.querySelectorAll('.product__cloth-wrap .product__cloth-item');
      this.clothColorsInputs = this.querySelectorAll('.cloth-colors input[type="radio"]');
      this.clothVariantPrice = this.querySelectorAll('.product__cloth-price');
      if(this.mainVariantPicker) {
        this.finishOptions = this.mainVariantPicker.querySelectorAll('input[name="Finish"');
      }
      this.init();
    }
    
    initDefaultVariantInfo() {
      const defaultVariantInfo = document.getElementById('default-variant-info');
      if (defaultVariantInfo) {
        const variantData = JSON.parse(defaultVariantInfo.textContent);
        this.mainProductSelectedVariant = variantData;
      }
    }
    init() {
      let selectedClothColor = document.querySelector('.cloth-colors input[type="radio"]:checked').value;
      let selectedClothType = document.querySelector('.cloth-types input[type="radio"]:checked').value;

      this.selectedClothColor = selectedClothColor;
      this.selectedClothType = selectedClothType;
      
      for (let i = 0; i < this.clothOptionInputs.length; i++) {
        const optionProductInput = this.clothOptionInputs[i];
        const optionProductId = optionProductInput.dataset.productId;
        const optionProductData = this.clothOptionsData[optionProductId];
        const viableVariant = optionProductData.variants.find(this.getClothVariantViability.bind(this)); // each option product can have at most one viable variant
        this.selectedClothVariant = this.findVariantByTypeAndColor(optionProductData.variants, selectedClothType, selectedClothColor);
  
        if (viableVariant) {
          optionProductInput.removeAttribute("disabled");
          // Select first viable option
          if (!this.selectedClothInput) {
            this.selectedClothInput = optionProductInput;
            this.selectedClothInput.checked = true;
            this.selectedClothVariant = viableVariant;
          }
        } else {
          optionProductInput.checked = false;
          optionProductInput.setAttribute("disabled", true);
        }
      }
  
      // If no option products are viable, disable the Add to Cart CTA
      this.setClothColorVariantLabel();
      this.setCtaEnabled(!!this.selectedClothInput);
      this.addEventListener('change', this.onOptionProductChange.bind(this));
      document.addEventListener('VariantChanged', this.onMainProductVariantChange.bind(this));
      document.addEventListener('AddToCart', this.onAddToCart.bind(this));
      this.mainQuantityInput.addEventListener('change', this.onQuantityChange.bind(this));
      this.onOptionChangeMedia(this.selectedClothVariant.id);
    }

    setClothColorVariantLabel() {
      let colorLabel = document.querySelector(".cloth-types .color_label");
      let colorInputs = document.querySelectorAll("input[name='Cloth Color']")

      for (var i = 0; i < colorInputs.length; i++) {
        if (colorInputs[i].checked) {
        colorLabel.innerHTML += "<span class='color__variant'> - " + colorInputs[i].value + "</span>"
        }
      }
    }

    removeClothColorVariantLabel() {
      let colorVariant = document.querySelector(".color__variant");
        if (colorVariant !== 'undefined' && colorVariant !== null) {
        colorVariant.remove()
      }
    }

    onOptionChangeMedia(currentVariantId) {
      const optionProductInput = this.clothOptionInputs[0];
      const optionProductId = optionProductInput.dataset.productId;
      const optionProductData = this.clothOptionsData[optionProductId];
      const pocketValue = document.querySelector('select[name="options[Pockets]"');

      if(!this.mainVariantPicker) {
        this.whenMainProductWithoutOptionsMedia(currentVariantId);
      }
  
      if (this.finishOptions) {
        this.finishOptions.forEach( finish => {
          optionProductData.variants.forEach( variant => {
            if (variant.id === currentVariantId) {
              const clothPattern = /cloth-(.*?)\.jpg/;
              const finishPattern = /finish-(.*?)__/;
              const pocketPattern = /pockets-(.*?)__/;
              const skuPattern = /sku-(.*?)__/;
              
              if (variant?.images && finish.checked) {
                variant.images.forEach( img => {
                  const finishMatch = finishPattern.exec(img.cloth_image)  
                  const clothMatch = clothPattern.exec(img.cloth_image);
                  const pocketMatch = pocketPattern.exec(img.cloth_image)
                  const skuMatch = skuPattern.exec(img.cloth_image_handle)

                  if (finishMatch && clothMatch && pocketMatch) {
                    if (variant.color_handle === clothMatch[1] && finish.value.toLowerCase() === finishMatch[1] && pocketValue.value.toLowerCase() === pocketMatch[1]) {
                      this.updateImageSrc(img.cloth_image)
                    }
                  } else if (finishMatch && clothMatch) {
                   
                    if (variant.color_handle === clothMatch[1] && finish.value.toLowerCase() === finishMatch[1]) {
                      this.updateImageSrc(img.cloth_image)
                    }
                  } else if (pocketMatch && clothMatch) {
                    if (variant.color_handle === clothMatch[1] && pocketValue.value.toLowerCase() === pocketMatch[1]) {
                      this.updateImageSrc(img.cloth_image)
                    }
                  }else{
                    if(skuMatch && skuMatch[1].toLowerCase() == this.mainProductSelectedVariant?.sku.toLowerCase()){
                      this.updateImageSrc(img.cloth_image);
                    }
                  }
                })
              }   
            }
          })
        })
      }
      
    }

    whenMainProductWithoutOptionsMedia(currentVariantId) {
      const optionProductInput = this.clothOptionInputs[0];
      const optionProductId = optionProductInput.dataset.productId;
      const optionProductData = this.clothOptionsData[optionProductId];

      optionProductData.variants.forEach( variant => {
        if (variant.id === currentVariantId) {
          const clothPattern = /cloth-(.*?)\.jpg/;  
          if (variant?.images) {   
            variant.images.forEach( img => {           
              const clothMatch = clothPattern.exec(img.cloth_image);   
              if (clothMatch) {     
                if (variant.color_handle === clothMatch[1]) {  
                  //this.updateImageSrc(img.cloth_image)
                }
              } 
            })
          }   
        }
      })
    }

    updateImageSrc(src) {
      document.querySelector(".product__media-item .product__media").firstElementChild.srcset = src;
      document.querySelector(".product__media-item .product__media").firstElementChild.src = src;
      document.querySelector(".product-media-modal__content").firstElementChild.srcset = src;
      document.querySelector(".product-media-modal__content").firstElementChild.src = src;
    }
  
    onOptionProductChange(event) { 
      if(event.target.name == "Cloth Color") {
        this.clothColorsInputs.forEach(input => (
          input.classList.remove("checked")
        ))
      }

      if(event.target.name == "Cloth Type") {
        this.clothTypesInputs.forEach(input => (
          input.classList.remove("checked")
        ))
        event.target.parentElement.parentElement.classList.add("checked")
      } else {
        event.target.classList.add("checked")
      }

      this.selectedClothInput = event.target;
      let selectedClothColor = document.querySelector('.cloth-colors input[type="radio"]:checked').value;
      let selectedClothType = document.querySelector('.cloth-types input[type="radio"]:checked').value;

      if(this.selectedClothInput.name === "Cloth Type"){
        selectedClothType = this.selectedClothInput.value;
      }else{
        selectedClothColor = this.selectedClothInput.value;
      }

      this.selectedClothColor = selectedClothColor;
      this.selectedClothType = selectedClothType;

      const clothProductId = this.selectedClothInput.dataset.productId;
      const clothProductData = this.clothOptionsData[clothProductId];
      this.selectedClothVariant = this.findVariantByTypeAndColor(clothProductData.variants, selectedClothType, selectedClothColor);
      this.onOptionChangeMedia(this.selectedClothVariant.id);

      this.setCtaEnabled(true);
      this.setClothColorVariantLabel();
      this.removeClothColorVariantLabel();
    }
  
    onQuantityChange() {
      this.quantity = Number(this.mainQuantityInput.value);
      this.onMainProductVariantChange();
    }
  
    setMainProductSelectedVariant(variant) {
      this.mainProductSelectedVariant = variant;
    }
  
    onMainProductVariantChange(event) {
      if (event) {
        this.setMainProductSelectedVariant(event.detail.variant);
        // this.init(); // kal
      }
      let isSelectedClothVariantViable = this.getClothVariantViability(this.selectedClothVariant);
      
      for (let i = 0; i < this.clothOptionInputs.length; i++) {
        const clothOptionInput = this.clothOptionInputs[i];  
        const clothProductId = clothOptionInput.dataset.productId;
        const clothProductData = this.clothOptionsData[clothProductId];
        const viableClothVariant = this.findVariantByTypeAndColor(clothProductData.variants, this.selectedClothType, this.selectedClothColor);
        
        if (viableClothVariant) {
          clothOptionInput.removeAttribute("disabled");
          // If previously selected variant no longer viable, select the earliest viable option
          if (!isSelectedClothVariantViable) {
            this.selectedClothInput = clothOptionInput;
            this.selectedClothInput.checked = true;
            this.selectedClothVariant = viableClothVariant;
            isSelectedClothVariantViable = true;
          }
  
          this.setCtaEnabled(true);
        } else {
          clothOptionInput.setAttribute("disabled", true);
          clothOptionInput.checked = false;
        }
      }
  
      // If no options are viable, disable the Add to Cart CTA
      if (!isSelectedClothVariantViable) {
        this.selectedClothInput = null;
        this.selectedClothVariant = null;
        this.setCtaEnabled(false);
      }
      this.removeClothColorVariantLabel();
      this.setClothColorVariantLabel();
    }

    findVariantByTypeAndColor(variants, typeHandle, colorHandle) {
      for (const variant of variants) {
          if (variant.type_handle === typeHandle && variant.color_handle === colorHandle) {
              return variant;
          }
      }
      return null;
  }
  
    /** Adds currently selected Cloth to cart, associating it with the given line_item_key */
    onAddToCart(event) {
      if (!event?.detail?.line_item_key) return;
      
      // Private line item properties
      const properties = {
        "_hiddenFromCartCount": true,
        "_associatedWithLineItemKey": event.detail.unique_hash,
      };
      
      // Public line item properties
      properties[window.Resources.pdp.cloth_selection.added_with] = this.mainProductSelectedVariant.name;
  
      const body = JSON.stringify({
        id: this.selectedClothVariant.id, 
        quantity: this.quantity,
        properties,
      });
  
      fetch(`${window.routes.cart_add_url}`, {...fetchConfig(), ...{ body }});
    }
  
    getSelectedRequiredCloth() {
      const clothType = this.mainProductSelectedVariant.type_handle;
      const clothColor = this.mainProductSelectedVariant.color_handle;
  
      const clothTypeIndex = this.clothTypeArray.indexOf(clothType);
      const skateLength = this.skateLengthObject[clothColor][clothTypeIndex];
      const requiredClothSize = this.skateLengthToClothSizeMap[skateLength];
  
      return requiredClothSize;
    }
  
    getClothVariantViability(clothVariant) {
      if (!clothVariant) return false;    
      const hasSufficientQty = clothVariant.quantity >= this.quantity || (clothVariant.quantity === 0 && clothVariant.available);
      return hasSufficientQty;
    }
  
    setCtaEnabled(isEnabled) {
      // If the CTA is already disabled, it means the main product is out of stock. Don't do anything.
      if (this.cta.getAttribute('disabled')) return;
  
      if (isEnabled) {
        const clothPrice = Number(document.querySelector(".price-item")?.dataset?.price);
        const totalPrice = (clothPrice + this.selectedClothVariant.price)/100;
        const displayPrice = totalPrice.toLocaleString(undefined, {style: 'currency', currency: this.dataset.currencyCode});
        this.ctaLabel.textContent = `${window.variantStrings.addToCart} - ${displayPrice}`;
      } else {
        this.cta.setAttribute('disabled', 'disabled');
        this.ctaLabel.textContent = window.Resources.pdp.cloth_selection.cloth_out_of_stock;
      }
    }
  }
  
  customElements.define('cloth-selection', ClothSelection);